/**
 * Handles form submission via fetch() to the public API
 */

export interface SubmitData {
  email: string;
  fields: Record<string, unknown>;
  consentGiven: boolean;
  pageUrl?: string;
  referrerUrl?: string;
  _hp?: string;
  _ts?: number;
  anonymousId?: string;
}

export interface SubmitResult {
  success: boolean;
  message: string;
  downloadUrl?: string;
  redirectUrl?: string;
}

export async function submitForm(
  apiUrl: string,
  websiteFormId: string,
  data: SubmitData,
): Promise<SubmitResult> {
  const url = `${apiUrl}/api/v1/public/forms/${websiteFormId}/submit`;

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });

  if (response.status === 429) {
    const retryAfter = response.headers.get("retry-after");
    return {
      success: false,
      message: `Too many submissions. Please try again${retryAfter ? ` in ${retryAfter} seconds` : " in a moment"}.`,
    };
  }

  if (response.status === 400) {
    const body = await response.json().catch(() => null);
    return {
      success: false,
      message:
        (body as { message?: string })?.message ??
        "Please check your input and try again.",
    };
  }

  if (!response.ok) {
    return {
      success: false,
      message: "Something went wrong. Please try again.",
    };
  }

  return (await response.json()) as SubmitResult;
}
